export default function Col({
  className,
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  xsOffset,
  smOffset,
  mdOffset,
  lgOffset,
  xlOffset,
  xxlOffset,
  ...props
}) {
  const localClassName = [
    "col",
    (!!xs && `col-xs-${xs}`) || "",
    (!!sm && `col-sm-${sm}`) || "",
    (!!md && `col-md-${md}`) || "",
    (!!lg && `col-lg-${lg}`) || "",
    (!!xl && `col-xl-${xl}`) || "",
    (!!xxl && `col-xxl-${xxl}`) || "",
    (!!xsOffset && `col-xs-offset-${xsOffset}`) || "",
    (!!smOffset && `col-sm-offset-${smOffset}`) || "",
    (!!mdOffset && `col-md-offset-${mdOffset}`) || "",
    (!!lgOffset && `col-lg-offset-${lgOffset}`) || "",
    (!!xlOffset && `col-xl-offset-${xlOffset}`) || "",
    (!!xxlOffset && `col-xxl-offset-${xxlOffset}`) || "",
  ]
    .join(" ")
    .trim();
  return (
    <div className={localClassName} {...props}>
      {children}
    </div>
  );
}

Col.defaultProps = {
  className: "",
  xs: 12,
  xsOffset: 0,
};
